import { useState } from 'react';
import iconGringao from '../../assets/iconegringao.png';
import styles from './ProductImage.module.css';

const ProductImage = ({ src, alt, className }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Se não há src ou deu erro, mostra placeholder
  const shouldShowPlaceholder = !src || hasError || src === 'null' || src === 'undefined' || src.trim() === '';
  const imageSrc = shouldShowPlaceholder ? iconGringao : src;

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  return (
    <div className={`${styles.container} ${className || ''}`}>
      {isLoading && !shouldShowPlaceholder && (
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
        </div>
      )}
      <img
        src={imageSrc}
        alt={alt || 'Produto'}
        className={`${styles.image} ${isLoading ? styles.imageLoading : ''}`}
        onLoad={handleLoad}
        onError={handleError}
        loading="lazy"
        referrerPolicy="no-referrer"
      />
    </div>
  );
};

export default ProductImage;
